import React from "react";

/**
 * SimplifyInfoModal - Help/how-to modal for Jet Set Go feature
 *
 * Props:
 * - show: boolean - Whether modal is visible
 * - onClose: () => void - Handler to close modal
 */

const SimplifyInfoModal = ({ show, onClose }) => {
  if (!show) return null;

  return (
    <div
      className="safe-area-overlay"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: "var(--bg-primary, white)",
          borderRadius: "8px",
          padding: "2rem",
          maxWidth: "500px",
          width: "90%",
          maxHeight: "80dvh",
          overflow: "auto",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header with close button */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1.5rem" }}>
          <h2 style={{ margin: 0, color: "var(--text-primary, #333)" }}>How Jet Set Go Works</h2>
          <button
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              fontSize: "1.5rem",
              cursor: "pointer",
              color: "var(--text-secondary, #666)",
            }}
          >
            ×
          </button>
        </div>

        {/* Content */}
        <div style={{ color: "var(--text-primary, #333)", lineHeight: "1.6" }}>
          <p style={{ margin: "0 0 1rem 0" }}>
            <strong>Jet Set Go</strong>
          </p>
          <div style={{ margin: "1.5rem 0" }}>
            <h3 style={{ margin: "0 0 0.5rem 0", fontSize: "1rem" }}>How it works:</h3>
            <ol style={{ margin: 0, paddingLeft: "1.5rem" }}>
              <li style={{ marginBottom: "0.5rem" }}>
                <strong>Set your scene</strong> Choose how many you are, your mood and whether you want to compete or co-operate.
              </li>
              <li style={{ marginBottom: "0.5rem" }}>
                <strong>Choose your games</strong> - Or login and let Pista pick from your collection
              </li>
              <li style={{ marginBottom: "0.5rem" }}>
                <strong>Start Playing</strong> - Pista ranks your games and starts you off right away!
              </li>
            </ol>
          </div>
        </div>

        {/* Action button */}
        <div style={{ display: "flex", justifyContent: "center" }}>
          <button
            onClick={onClose}
            style={{
              padding: "0.75rem 2rem",
              border: "none",
              borderRadius: "4px",
              backgroundColor: "var(--primary-color, #1976d2)",
              color: "white",
              cursor: "pointer",
              fontSize: "1rem",
              fontWeight: "600",
            }}
          >
            Got it, let&apos;s start!
          </button>
        </div>
      </div>
    </div>
  );
};

export default SimplifyInfoModal;
